import { get } from 'lodash';
import Service from '../../services';

export const getCategories = async params => {
  const response = await Service.isnGet(`/api/aboutus/get-categories${params}`, res => res);
  return response;
};
export const getCompanyProfile = async params => {
  const response = await Service.isnGet(`/api/aboutus/get-company-profiles${params}`, res => res);
  return response;
};

export const getCompanyPhilosophies = async params => {
  const response = await Service.isnGet(`/api/aboutus/get-philosophies${params}`, res => res);
  return response;
};

export const getFlesta = async params => {
  const response = await Service.isnGet(`/api/aboutus/get-flestas${params}`, res => res);
  return response;
};

export const getMeetOurTeam = async params => {
  const response = await Service.isnGet(`/api/aboutus/get-meet-our-team${params}`, res => res);
  return response;
};

export const getWhyChooseUs = async params => {
  const response = await Service.isnGet(`/api/aboutus/get-why-choose-us${params}`, res => res);
  return response;
};

export const getServices = async params => {
  const response = await Service.isnGet(`/api/aboutus/get-services${params}`, res => res);
  return response;
};

export const getGroupCompany = async params => {
  const response = await Service.isnGet(`/api/aboutus/get-group-company${params}`, res => res);
  return response;
};

export const getHistory = async params => {
  const response = await Service.isnGet(`/api/generalinformations/histories${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getNewsRelease = async params => {
  const response = await Service.isnGet(`/api/blogs${params}`, res => res);
  return response;
};

export const getOfficeInformation = async params => {
  const response = await Service.isnGet(`/api/generalinformations/get-contact-us${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getNewsContent = async params => {
  const response = await Service.isnGet(`/api/blogs/detail${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const fetchOtherNews = async params => {
  const response = await Service.isnGet(`/api/blogs/other${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const postContactUsRequest = async params => {
  const response = await Service.isnPostFormData(`/api/aboutus/submit-form-contact`, params, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getOverviewHousingMaterials = async params => {
  const response = await Service.isnGet(`/api/aboutus/get-overviews${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getDetailsHousingMaterials = async params => {
  const response = await Service.isnGet(`/api/aboutus/get-details${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getFeaturesHousingMaterials = async params => {
  const response = await Service.isnGet(`/api/aboutus/get-features${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
}

export const getGalleriesHousingMaterials = async params => {
  const response = await Service.isnGet(`/api/aboutus/get-galleries${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
}

export const getGalleriesProductHousingMaterials = async params => {
  const response = await Service.isnGet(`/api/aboutus/get-galleries-product${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
}

export const getHousingMaterialProducts = async params => {
  const response = await Service.isnGet(`/api/aboutus/get-material-products${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
}

export const getBanner = async params => {
  const response = await Service.isnGet(`/api/aboutus/get-by-id${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
}

